import { render, staticRenderFns } from "./BiozidCheckout.vue?vue&type=template&id=844d2c8c&"
import script from "./BiozidCheckout.vue?vue&type=script&lang=js&"
export * from "./BiozidCheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/danielkaschlaw/Desktop/Sites/devTools_shit/11228/83/MGCRedesign/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('844d2c8c')) {
      api.createRecord('844d2c8c', component.options)
    } else {
      api.reload('844d2c8c', component.options)
    }
    module.hot.accept("./BiozidCheckout.vue?vue&type=template&id=844d2c8c&", function () {
      api.rerender('844d2c8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/checkout/BiozidCheckout.vue"
export default component.exports